import { forwardRef, RefObject } from 'react';
import { Link as RrdLink, LinkProps } from 'react-router-dom';

import { Button, ButtonProps } from '@components/base';

export type RouterButtonProps = Omit<LinkProps, 'instance'> &
  Omit<ButtonProps, 'component' | 'href'>;

export const RouterButton = forwardRef<HTMLButtonElement, RouterButtonProps>((props, ref) => (
  <Button {...props} component={RrdLink} ref={ref as RefObject<HTMLButtonElement>} />
));

RouterButton.displayName = 'RouterButton';
